import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class WaiverQueryFilter extends QueryFilter {
    public organizationId: string;
} 